import React, { useState, useEffect, useRef, useContext } from "react";
import { Alert, Button, Card, Col, Container, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Pagination, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import {
  IconBasket1,
  IconBell,
  IconCancelTicket,
  IconChevronLeft,
  IconClipBoard,
  IconCup,
  IconErrorCircle,
  IconFast,
  IconGift,
  IconLocation1,
  IconNote,
  IconSecurity,
} from "../../../assets/icons";
import ReserveModal from "./component/reserveModal";
import SplitNumber from "../../components/SplitNumber";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { isMobile } from "react-device-detect";
import _ from "lodash";
import enamadImage from "../../../assets/images/e-namad.png";
import ApiAmusementService from "../../../core/api/api.amusementService";
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import CommentScore from "./component/CommentScore";
import CommentSlider from "./component/CommentSlider";
import { Helmet } from "react-helmet-async";
import Slider from "./component/Slider";
import CardTile from "../../components/CardTile";
import SkeletonDetailsContetnt from "../../components/SkeletonComponent/SkeletonDetailsContetnt";
import ServiceStorage from "../../../core/services/service.storage";
import ContextApp from "../../../core/contexts/context.app";
import { ToastContainer, toast } from "react-toastify";
import getCityDataAndSaveToStorage from "../../components/GetCityListAndSaveToStorage";
import SchemaMarkup from "./component/Schema";
import LocationMap from "./component/LocationMap";

function IndexAmusementDetail() {
  const [loadingImageSlider, setLoadingImageSlider] = useState(true);
  const [dataImageSlider, setDataImageSlider] = useState([]);
  const [amusementService, setAmusementService] = useState({});
  const [reserveDetail_V2, setReserveDetail_V2] = useState({});
  const [showTooltip, setShowTooltip] = useState(false)
  const [galleries, setGalleries] = useState([]);
  const { urlName } = useParams(); // دریافت پارامتر urlName از روت

  const location = useLocation();
  const navigate = useNavigate();
  const ctx = useContext(ContextApp);

  /***نمایش و عدم نمایش تب ها*******************/
  const sections = [
    { id: "buySection", title: "خرید بلیط" },
    { id: "rulesSection", title: "نکات مهم" },
    { id: "decriptionSection", title: "توضیحات" },
    { id: "scoreSection", title: "نظرات خریداران" },
  ];
  const [active, setActive] = useState(sections[0].id);
  const [showNav, setShowNav] = useState(false);
  const sectionRefs = useRef({});
  const navRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      // نمایش منو بعد از 100px
      setShowNav(scrollY > 100);

      const navHeight = navRef.current?.offsetHeight || 0;
      const scrollPos = scrollY + navHeight + 40;

      let current = sections[0].id;
      sections.forEach((s) => {
        const el = sectionRefs.current[s.id];
        if (el && el.offsetTop <= scrollPos) {
          current = s.id;
        }
      });

      // رسیدن به پایین صفحه
      if (window.innerHeight + scrollY >= document.body.offsetHeight - 20) {
        current = sections[sections.length - 1].id;
      }

      setActive(current);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const el = sectionRefs.current[id];
    if (el) {
      const navHeight = navRef.current?.offsetHeight || 0;
      window.scrollTo({
        top: el.offsetTop - navHeight - 40,
        behavior: "smooth",
      });
    }
  };
  /**** وقتی وارد این صفحه می شود اسکرول بخوره به ابتدای صفحه **********************/
  const handleClick = (value) => { };
  // init flag to false
  useEffect(() => {
    window.__prerenderReady = false;
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiAmusementService.getAmusementService({
          urlName,
        });
        if (!response) {
          navigate("../PageNotFound");
        }

        setAmusementService(response);
        setGalleries(response.amusementServiceSliders);
        setLoadingImageSlider(false);
        const cityIdFromServer = response.defaultCityId;
        const storageCity = ServiceStorage.getCity();

        if (cityIdFromServer != null) {
          if (!_.isNil(storageCity)) {
            const cityList = JSON.parse(storageCity.cityList);
            const item = cityList.find((city) => city.id == cityIdFromServer);
            ctx.setSelectedCity(item);
            ServiceStorage.setSelectedCity(item);
          } else {
            // اطلاعاتی در داخل لوکال استوریچ وجود ندارد(دفعه اول)
            const { newUpdateDate, regoinResult } =
              await getCityDataAndSaveToStorage();
            const selectedCity = regoinResult.find(
              (city) => city.id == cityIdFromServer
            );
            ctx.setSelectedCity(selectedCity);
            ServiceStorage.setCity({
              cityListLastUpdate: newUpdateDate,
              cityList: regoinResult,
              selectedCity,
            });
          }
        }
        // وقتی داده‌ها آماده شدند، Ready را true می‌کنیم
        window.__prerenderReady = true;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
      }
    };
    fetchData();
  }, [urlName]);

  /*** مدال رزرو ******************** */
  const [showReserveModal, setShowReserveModal] = useState(false);
  const isPushed = useRef(false); // جلوگیری از push اضافی

  const openModal = () => {
    if (!isPushed.current) {
      window.history.pushState({ modal: true }, "");
      isPushed.current = true;
    }
    setShowReserveModal(true);
  };
  const closeModal = () => {
    setShowReserveModal(false);
    // بازگشت به حالت قبل (popstate خودکار اجرا نمیشه)
    if (isPushed.current) {
      window.history.back();
      isPushed.current = false;
    }
  };
  useEffect(() => {
    const handlePopState = (e) => {
      if (showReserveModal && isPushed.current) {
        setShowReserveModal(false);
        isPushed.current = false;
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [showReserveModal]);

  /************************** */

  /********************* */
  const SetColor = (rank) => {
    if (rank < 2) return "text-danger fs-103 fw-bold";
    else if (rank >= 4) return "text-success fs-103 fw-bold";
    else return "text-warning fs-103 fw-bold";
  };
  /************************ */
  //اسکرول به قسمت امتیازات در حالت دسکتاپ
  const ScrollGotoScore = useRef(null);
  const handleScrollGotoScore = () => {
    if (ScrollGotoScore.current) {
      ScrollGotoScore.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  /************************ */
  //اسکرول به قسمت نظرات در حالت دسکتاپ
  const ScrollGotoComment = useRef(null);
  const handleScrollGotoComment = () => {
    if (ScrollGotoComment.current) {
      ScrollGotoComment.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  /******************* */

  const handleCopy = () => {
    // استفاده از navigator.clipboard.writeText
    navigator.clipboard
      .writeText(amusementService.suggestedPromoCode)
      .then(() => {
        toast.success("کد تخفیف کپی شد.", {
          duration: 10000,
          position: "top-right",
        });
      })
      .catch((error) => {
        console.error("خطا در کپی کردن متن:", error);
      });
  };

  /**************************** */
  const pageDescriptionAmusementServiceGroupName =
    amusementService.amusementServiceAmusementGroups?.map(
      (grp) => grp.amusementGroup.title
    );

  const pageDescriptionAmusementServiceRegionsName =
    amusementService.amusementServiceRegions
      ?.map((rgn) => rgn.region.name)
      .join("، ");

  /****************************** */
  /************************************* */
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response =
          await ApiAmusementService.getAmusementServiceReserveDetail_V2({
            urlName: urlName,
          });
        setReserveDetail_V2(response);
      } catch (error) {
      } finally {
      }
    };
    fetchData();
  }, [urlName]);
  return (
    <>
      {/* <ToastContainer position="top-right" rtl="true"></ToastContainer> */}
      {!_.isEmpty(amusementService) && (
        <>
          <div className="wrapper">
            <Helmet>
              <title>
                {!_.isEmpty(amusementService.pageTitle)
                  ? amusementService.pageTitle
                  : amusementService.name}
              </title>
              <link
                href={
                  window.location.origin +
                  "/details/" +
                  amusementService.urlName
                }
                rel="canonical"
              ></link>
              <meta
                property="og:url"
                content={
                  window.location.origin +
                  "/details/" +
                  amusementService.urlName
                }
              />
              <meta
                property="og:title"
                content={
                  !_.isEmpty(amusementService.pageTitle)
                    ? amusementService.pageTitle
                    : amusementService.name
                }
              />

              <meta
                property="og:description"
                content={
                  !_.isEmpty(amusementService.metaDescription)
                    ? amusementService.metaDescription
                    : // : "خرید ویژه با تخفیف ویژه"
                    `${amusementService.name} تجربه ای متفاوت از ${pageDescriptionAmusementServiceGroupName} در شهر ${pageDescriptionAmusementServiceRegionsName} با تخفیف های واقعی، رزرو آنلاین، قیمت مناسب و پشتیبانی ۲۴ ساعته تفریحان. همین حالا انتخاب کن و یک روز هیجان انگیز  بساز!`
                }
              />

              <meta
                name="description"
                content={
                  !_.isEmpty(amusementService.metaDescription)
                    ? amusementService.metaDescription
                    : `${amusementService.name} تجربه ای متفاوت از ${pageDescriptionAmusementServiceGroupName} در شهر ${pageDescriptionAmusementServiceRegionsName} با تخفیف های واقعی، رزرو آنلاین، قیمت مناسب و پشتیبانی ۲۴ ساعته تفریحان. همین حالا انتخاب کن و یک روز هیجان انگیز بساز!`
                }
              />
              {amusementService.isNoIndex && (<meta name="robots" content="noindex" />)}
            </Helmet>
          </div>
          <SchemaMarkup
            // data={amusementService}
            totalRank={amusementService.totalRank}
            amusementTestimonials={amusementService.amusementTestimonials}
            imagesListSlider={amusementService.amusementServiceSliders}
            mainListImage={amusementService.imageUrl}
            hasReserve={amusementService.hasReserveDetail_V2 ? true : false}
            price={amusementService.price}
            originalPrice={amusementService.originalPrice}
            metaDescription={amusementService.metaDescription}
            urlName={amusementService.urlName}
            name={amusementService.name}
            nameEn={amusementService.nameEn}
            pageTitle={amusementService.pageTitle}
            groupName={pageDescriptionAmusementServiceGroupName}
            //videos={amusementService.videos}
            lat={amusementService.lat}
            lon={amusementService.lon}
            region={amusementService?.amusementServiceRegions[0]?.region}
            group={amusementService?.amusementServiceAmusementGroups[0]?.amusementGroup}
          />
        </>
      )}
      {isMobile ? (
        //**** * حالت موبایل**********************************
        <div className="">
          {/*****  تب ها ***********************/}
          {showNav && (
            <div className="tabs" ref={navRef}>
              {sections.map((sec) => (
                <button
                  key={sec.id}
                  onClick={() => scrollToSection(sec.id)}
                  className={active === sec.id ? "active" : ""}
                >
                  {sec.title}
                </button>
              ))}
            </div>
          )}
          {/***** breadCrumb  ***********************/}
          {!loadingImageSlider &&
            amusementService?.amusementServiceRegions.length > 0 &&
            amusementService?.amusementServiceAmusementGroups.length > 0 && (
              <div className="pt-3 px-3 text-secondary fs-08 prerender-version">
                <Link className=" text-secondary " to="/">
                  صفحه اصلی
                </Link>
                <span className="mx-1 very-small-svg">
                  <IconChevronLeft />
                </span>
                <Link
                  className=" text-secondary "
                  to={`/c/${amusementService?.amusementServiceRegions[0]?.region?.englishName}/${amusementService?.amusementServiceAmusementGroups[0]?.amusementGroup.urlName}`}
                >
                  <span className="d-inline-block">
                    {pageDescriptionAmusementServiceGroupName?.[0]}
                  </span>
                  <span className="d-inline-block ps-1">
                    {pageDescriptionAmusementServiceRegionsName?.split("،")[0]}
                  </span>
                </Link>
              </div>
            )}
          <Container
            className="pt-3 px-2"
            key={sections[0].id}
            ref={(el) => (sectionRefs.current[sections[0].id] = el)}
          >
            <Card className=" shadow-sm rounded-3">
              <Card.Body className=" p-2">
                {loadingImageSlider ? (
                  <>
                    <SkeletonTheme>
                      <Skeleton
                        height={258}
                        width="100%"
                        style={{ borderRadius: "0.75rem" }}
                      ></Skeleton>
                    </SkeletonTheme>
                  </>
                ) : (
                  <Slider
                    images={galleries}
                    amusementNameText={amusementService.name}
                  />
                )}

                <div className="mt-3">
                  {loadingImageSlider ? (
                    <SkeletonTheme>
                      <div className=" border-bottom pb-3">
                        <Skeleton height="25px" width="100%"></Skeleton>
                      </div>
                      <div className="d-flex justify-content-between mt-3 mb-2">
                        <div className="text-start w-50">
                          <Skeleton height="25px" width="80%"></Skeleton>
                        </div>
                        <div className="text-end w-50">
                          <Skeleton height="25px" width="80%"></Skeleton>
                        </div>
                      </div>
                      <Skeleton height="35px" width="100%"></Skeleton>
                    </SkeletonTheme>
                  ) : (
                    <>
                      <div className=" border-bottom pb-3 d-flex justify-content-center">
                        <h1 className=" fw-bold fs-101 mb-0">
                          {amusementService.name}
                        </h1>
                        {/* <div
                          className="fs-07 text-end text-secondary pt-1 ms-2"
                          style={{ minWidth: "80px" }}
                        >
                          <span className="d-inline-block">
                            {loadingImageSlider
                              ? "---"
                              : amusementService?.amusementTestimonials
                                  ?.length}{" "}
                            دیدگاه
                          </span>
                          <span className="d-inline-block px-1"> | </span>
                          <span className="d-inline-block">
                            {loadingImageSlider
                              ? "---"
                              : amusementService.totalRank}{" "}
                            امتیاز
                          </span>
                        </div> */}
                      </div>

                      {/* {amusementService.hasReserveDetail_V2 ? (
                        <> */}
                      <Row className="gx-0 mt-3">
                        {amusementService?.originalPrice >
                          amusementService?.price ? (
                          /************** اگر تخفیف داشت **************************/
                          <>
                            <Col className="text-start text-secondary">
                              <div className="fs-07">قیمت اولیه</div>
                              <div className=" mt-1 fs-08">
                                <span className="text-decoration-line-throught-rotate border-black fw-bold">
                                  <SplitNumber
                                    number={amusementService.originalPrice}
                                  />
                                </span>
                                <span className="ps-1">تومان</span>
                              </div>
                            </Col>
                            <Col className="text-danger text-center ">
                              <div className="small-svg fs-07 mb-1 ">
                                <IconGift fillColor="#f80248" /> تخفیف
                                  </div>
                              <div className="fs-08">
                                <span className=" fw-bold mt-1 ">
                                  <SplitNumber
                                    number={
                                      amusementService?.originalPrice -
                                      amusementService?.price
                                    }
                                  />
                                </span>
                                <span className="ps-1">تومان</span>
                              </div>
                            </Col>
                            <Col className="text-black text-end">
                              <div className="fs-07 text-secondary">
                                قیمت نهایی
                                  </div>
                              <div className="fs-08 mt-1">
                                <span className="fw-bold fs-09">
                                  <SplitNumber
                                    number={amusementService.price}
                                  />
                                </span>
                                <span className="ps-1">تومان</span>
                              </div>
                            </Col>
                          </>
                        ) : (
                          /************** اگر تخفیف نداشت **************************/
                          <Col className="text-black d-flex justify-content-between align-items-center">
                            <div className="fs-07 text-secondary">
                              قیمت نهایی
                                </div>
                            <div className="fs-08 mt-1">
                              <span className="fw-bold fs-09">
                                <SplitNumber
                                  number={amusementService.price}
                                />
                              </span>
                              <span className="ps-1">تومان</span>
                            </div>
                          </Col>
                        )}
                      </Row>

                      {amusementService.hasReserveDetail_V2 ?
                        <button
                          className="btn btn-success d-flex align-items-center w-100 p-0 btn-with-icon mt-3"
                          onClick={openModal}
                        >
                          <div
                            className="border-end border-success icon-span">
                            <IconBasket1 fillColor="#6c757d" />
                          </div>
                          <div className=" text-center flex-fill">
                            افزودن به سبد خرید
                        </div>
                        </button> :
                        <OverlayTrigger
                          placement="top"
                          trigger="click"
                          onEntered={() => {
                            setTimeout(() => {
                              setShowTooltip(false)
                            }, 2000)
                          }}
                          show={showTooltip}
                          overlay={
                            <Tooltip id="tooltip-disabled">
                              در حال حاضر این برنامه غیرفعال است.
                            </Tooltip>
                          }
                        >
                          <div
                            onClick={() => {
                              setShowTooltip(true)
                            }}
                            className="d-inline-block w-100 p-0 mt-3">
                            <button disabled className="btn btn-outline-secondary w-100 d-flex align-items-center btn-with-icon">
                              <div
                                className="border-end border-secondary icon-span">
                                <IconBasket1 fillColor="#6c757d" />
                              </div>
                              <div className=" text-center flex-fill">
                                افزودن به سبد خرید
                              </div>
                            </button>
                          </div>
                        </OverlayTrigger>
                      }
                      <div className=" prerender-version">
                        <ReserveModal
                          reserveDetail_V2_Data={reserveDetail_V2}
                          show={showReserveModal}
                          onClose={closeModal}
                          serviceInfo={{
                            id: amusementService.id,
                            name: amusementService.name,
                            urlName: urlName,
                            imageUrl: amusementService.imageUrl,
                          }}
                          isModal={false}
                        />
                        {/* <ReserveBoxFoPreRender
                              reserveFormData={reserveDetail_V2}
                              serviceInfo={{
                                id: amusementService.id,
                                name: amusementService.name,
                                urlName: urlName,
                                imageUrl: amusementService.imageUrl,
                              }}
                              isInModal={false}
                            /> */}
                      </div>
                      {amusementService.hasReserveDetail_V2 ? (
                        <div className="mt-2 fs-065 text-center user-version">
                          {/* <IconErrorCircle fillColor="#444" /> */}
                              جهت مشاهده سانس و تاریخ، روی دکمه{" "}
                          <span
                            className="text-success px-1"
                            onClick={openModal}
                          >
                            «افزودن به سبد خرید»
                              </span>
                              کلیک نمایید
                        </div>
                      ) : (
                        ""
                      )}
                      {/* </>
                      ) : (
                        <>
                          <Alert
                            variant="danger"
                            className="py-2 px-1 fs-075 mt-3 mb-0"
                          >
                            <IconErrorCircle fillColor="#58151c" /> تا اطلاع
                            ثانوی این تفریح غیرفعال می باشد.
                          </Alert>
                        </>
                      )} */}
                    </>
                  )}
                </div>
              </Card.Body>
              <Card.Footer className="bg-light border-top px-2">
                {/**** آیکن های اعتمادسازی *********************************/}
                <div className="gx-0 text-dark  small-svg d-flex justify-content-between">
                  <div className="text-center ">
                    <div className="fw-bold fs-065">
                      <span className="me-1">
                        <IconCancelTicket fillColor="#09a463" />
                      </span>
                      امکان کنسلی
                    </div>
                    <div className="fs-055 mt-1">به صورت آنلاین و تلفنی</div>
                  </div>
                  <div className="text-center ">
                    <div className="fw-bold fs-065">
                      <span className="me-1">
                        <IconFast fillColor="#09a463" />
                      </span>
                      صدور آنی بلیط
                    </div>
                    <div className="fs-055 mt-1">بـدون نیـاز به چـاپ بلـیط</div>
                  </div>
                  <div className="text-center ">
                    <div className="fw-bold fs-065">
                      <span className="me-1">
                        <IconSecurity fillColor="#09a463" />
                      </span>
                      تضـمین قیـمت
                    </div>
                    <div className="fs-055 mt-1">تفریحات با بیشترین تخفیف</div>
                  </div>
                </div>
              </Card.Footer>
            </Card>

            {/********** نکات مهم و ضروری *******************************/}

            <Card
              key={sections[1].id}
              ref={(el) => (sectionRefs.current[sections[1].id] = el)}
              className="rounded-3  shadow-sm text-center mt-3"
            >
              <Card.Body>
                <div>
                  <span className="pe-2">
                    <IconBell fillColor="#000" />
                  </span>
                  <h2 className="d-inline-block fw-bold fs-normal pb-3">
                    نکات مهم و ضروری {amusementService.name}
                  </h2>
                </div>
                {loadingImageSlider ? (
                  <SkeletonTheme>
                    <Skeleton height="15px" count={5}></Skeleton>
                  </SkeletonTheme>
                ) : (
                  <>
                    {!_.isEmpty(amusementService.suggestedPromoCode) ? (
                      <>
                        <div className="text-align-justify description-text d-flex align-items-center fw-bold">
                          <span> کد تخفیف خرید ارزان تر:</span>

                          <span className="text-danger mx-1">
                            {amusementService.suggestedPromoCode}
                          </span>
                          <Button
                            onClick={handleCopy}
                            variant="outline-secondary"
                            className="px-2 py-1 fs-07"
                          >
                            کپی
                          </Button>
                        </div>
                        <div className="text-align-justify description-text my-2 fw-bold">
                          (راهنما: تنها کافیست این کد تخفیف را در بخش سبد خرید
                          وارد نمایید.){" "}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    <div
                      className="text-align-justify description-text"
                      dangerouslySetInnerHTML={{
                        __html: amusementService.alerts,
                      }}
                    />
                    {/* <div className="text-align-justify description-text">
                      <a
                        href="https://www.instagram.com/tafrihancom?igsh=MTJtcWt2Y2IwcWgwdg=="
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#e33642" }}
                      >
                        <IconInstagram />
                        <span className="mx-1">مشاهده اینستاگرام </span>
                      </a>
                    </div> */}
                  </>
                )}
              </Card.Body>
            </Card>
            {/**********   بررسی اجمالی*******************************/}
            <Card
              key={sections[2].id}
              ref={(el) => (sectionRefs.current[sections[2].id] = el)}
              className="rounded-3  shadow-sm text-center mt-3"
            >
              <Card.Body>
                <div>
                  <span className="pe-2">
                    <IconNote fillColor="#000" />
                  </span>
                  <h2 className="d-inline-block fw-bold fs-normal pb-3">
                    بررسی اجمالی {amusementService.name}
                  </h2>
                </div>
                {loadingImageSlider ? (
                  <SkeletonTheme>
                    <Skeleton height="15px" count={5}></Skeleton>
                  </SkeletonTheme>
                ) : (
                  <>
                    <div
                      className="text-align-justify description-text"
                      dangerouslySetInnerHTML={{
                        __html: amusementService.description,
                      }}
                    />
                    <div className="text-align-justify description-text">
                      (<span className="fw-bold">توجه</span>: اطلاعات مندرج شده
                      در بخش بررسی اجمالی تفریح ممکن است بروز نباشد و یا توسط
                      مجموعه تفریحی تغییر کرده باشد و حتماً بخش نکات مهم و ضروری
                      در قسمت بالا هر تفریح را بررسی نمایید و در صورت داشتن هر
                      گونه سوال با پشتیبانی تفریحان تماس حاصل نمایید)
                    </div>
                  </>
                )}
              </Card.Body>
            </Card>
            {showReserveModal && (
              <ReserveModal
                reserveDetail_V2_Data={reserveDetail_V2}
                show={showReserveModal}
                onClose={closeModal}
                serviceInfo={{
                  id: amusementService.id,
                  name: amusementService.name,
                  urlName: urlName,
                  imageUrl: amusementService.imageUrl,
                }}
                isModal={true}
              />
            )}
          </Container>

          {/****  e-namad  ***************************************************/}
          <Container className="px-2">
            <Card
              className="mt-3 rounded-3  shadow-sm bg-white text-dark "
              style={{ lineHeight: "1.4rem" }}
            >
              <Card.Body className="py-2">
                <Row>
                  <Col className="pe-0 my-auto fs-08">
                    <div className="">
                      این وب سایت دارای{" "}
                      <span className="fw-bold">مجوز رسمی</span>
                    </div>
                    <div className="">
                      از{" "}
                      <span className="fw-bold">
                        سازمان میراث فرهنگی و گردشگری
                      </span>{" "}
                      و
                    </div>
                    <div>
                      <span className="fw-bold">وزارت صنعت و معدن</span> می
                      باشد.
                    </div>
                  </Col>
                  <Col xs="auto" className="text-end my-auto px-1">
                    <div>
                      <a
                        referrerPolicy="origin"
                        target="_blank"
                        href="https://trustseal.enamad.ir/?id=274889&amp;Code=A32132KLXam6f2jcPJyV"
                      >
                        <img
                          alt="eNamad"
                          referrerPolicy="origin"
                          className="rounded-3 h-100 "
                          src={enamadImage}
                          style={{ cursor: "pointer", width: "70px" }}
                          id="A32132KLXam6f2jcPJyV"
                        />
                      </a>
                    </div>
                    {/* <img
                      src={enamadImage}
                      alt="map"
                      style={{ width: "70px" }}
                    /> */}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Container>
          {/***** map ***************************** */}
          {amusementService.lat && amusementService.lon && (
            <Container className="px-2">
              <Card
                className="mt-3 rounded-3  shadow-sm bg-white text-dark "
                style={{ lineHeight: "1.4rem" }}
              >
                <Card.Body className="">
                  <h3 className=" fw-bold fs-09 mb-4 ">
                    موقعیت {amusementService.name} روی نقشه
                  </h3>
                  <LocationMap
                    lat={amusementService.lat}
                    lng={amusementService.lon}
                    amusementName={amusementService.name}
                  />
                  {amusementService?.address && (
                    <div className="mt-3">
                      آدرس : {amusementService?.address}
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Container>
          )}
          {/********** دسته بندی در حالت pre-render **********************/}
          <div className="scroll-container-box prerender-version">
            {amusementService?.cityAmusementGroups?.map((item) => (
              <Link
                to={`/c/${amusementService?.amusementServiceRegions[0].region
                  .englishName
                  }/${item.urlName?.split(" ").join("-")}`}
                className="scroll-item"
              >
                {item.title} {amusementService?.amusementServiceRegions[0].region.name}
              </Link>
            ))}
          </div>
          {/******** تفریحات مرتبط ***************************/}
          {amusementService?.relatedAmusementServices != null &&
            amusementService?.relatedAmusementServices.length > 0 && (
              <Container className="mt-4 pb-2">
                <h3 className=" fw-bold fs-normal "> تفریحات مرتبط </h3>
                {loadingImageSlider ? (
                  <Swiper
                    className="amusement-swiper"
                    spaceBetween={10}
                    slidesPerView={"auto"}
                  >
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                  </Swiper>
                ) : (
                  <Swiper
                    className="amusement-swiper"
                    spaceBetween={10}
                    slidesPerView={"auto"}
                  >
                    {amusementService?.relatedAmusementServices?.map((item) => (
                      <SwiperSlide key={item.id}>
                        <CardTile
                          itemImgSrc={
                            process.env.REACT_APP_API_URL + item.imageUrl
                          }
                          amusementUrl={`/details/${item.urlName}`}
                          amusementName={item.name}
                          amusementPrice={item.price}
                          amusementFinalPrice={item.originalPrice}
                          handleClick={handleClick}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                )}
              </Container>
            )}
          {/* <Container>
            <div className="bg-gradient-instagram my-3 px-3 py-3 text-white d-flex align-items-center justify-content-center rounded-3">
              <a
                href="https://www.instagram.com/tafrihancom?igsh=MTJtcWt2Y2IwcWgwdg=="
                target="_blank"
                rel="noopener noreferrer"
                className="text-white"
              >
                <IconInstagram />
                <span className="mx-2">اینستاگرام ما را دنبال کنید</span>
              </a>
            </div>
          </Container> */}
          <Container
            key={sections[3].id}
            ref={(el) => (sectionRefs.current[sections[3].id] = el)}
            fluid
            className="bg-light-blue pb-3"
          >
            <section>
              <CommentSlider amusementService={amusementService} />
            </section>
          </Container>

          {/* نوار سفید رنگ پایین که اگر تفریحی رزرو داشت نمایش داده می شود */}
          {amusementService.hasReserveDetail_V2 ? (
            <div
              className="d-flex justify-content-between align-items-center  w-100 bg-white px-3 py-2 position-fixed "
              style={{
                bottom: "56px",
                zIndex: "1044",
                borderTop: "1px solid #e7e6e6",
              }}
            >
              <div className="fs-075 fw-normal">
                {amusementService.originalPrice > amusementService.price ? (
                  <div className="mb-1 text-secondary">
                    <span className="text-decoration-line-throught-rotate border-black fw-bold">
                      <SplitNumber number={amusementService.originalPrice} />
                    </span>
                    <span className="ps-1">تومان</span>
                  </div>
                ) : (
                  ""
                )}

                <div className="fw-bold fs-09">
                  <SplitNumber number={amusementService.price} />
                  <span className="ps-1">تومان</span>
                </div>
              </div>

              <div>
                <div
                  onClick={openModal}
                  className="btn btn-danger text-white fs-09"
                >
                  افزودن به سبد خرید
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        //**** * حالت دسکتاپ**********************************
        <>
          <Container fluid className="pb-3">
            <Container className="pt-4 px-0">
              <Row className="gx-2">
                <Col lg="4" xl="auto">
                  <Card className="rounded-3 border-0 shadow-sm p-2 card-image-slider-amusement">
                    {loadingImageSlider ? (
                      <>
                        <SkeletonTheme>
                          <Skeleton
                            height={320}
                            width="100%"
                            style={{ borderRadius: "0.75rem" }}
                          ></Skeleton>
                        </SkeletonTheme>
                      </>
                    ) : (
                      <Slider
                        images={galleries}
                        amusementNameText={amusementService.name}
                      />
                    )}
                  </Card>
                </Col>
                <Col lg="8" xl className=" pt-3 pt-lg-0">
                  <Card className="rounded-3 bg-white border-0  shadow-sm h-100">
                    <Card.Body className="pb-0">
                      <Col xs={12}>
                        <Row className="text-primary1 pb-3">
                          <Col xs className=" my-auto">
                            {!loadingImageSlider &&
                              amusementService?.amusementServiceRegions.length >
                              0 &&
                              amusementService?.amusementServiceAmusementGroups
                                .length > 0 && (
                                <div className="text-secondary mb-2 opacity-60 fs-075 prerender-version">
                                  <Link className=" text-secondary " to="/">
                                    صفحه اصلی
                                  </Link>
                                  <span className="mx-1 very-small-svg">
                                    <IconChevronLeft />
                                  </span>
                                  <Link
                                    className=" text-secondary "
                                    to={`/c/${amusementService?.amusementServiceRegions[0]?.region?.englishName}/${amusementService?.amusementServiceAmusementGroups[0]?.amusementGroup.urlName}`}
                                  >
                                    <span className="d-inline-block">
                                      {
                                        pageDescriptionAmusementServiceGroupName?.[0]
                                      }
                                    </span>
                                    <span className="d-inline-block ps-1">
                                      {
                                        pageDescriptionAmusementServiceRegionsName?.split(
                                          "،"
                                        )[0]
                                      }
                                    </span>
                                  </Link>
                                </div>
                              )}

                            {!loadingImageSlider ? (
                              <h1 className="fw-bold mb-0 fs-103 border-light-blue">
                                {amusementService.name}
                              </h1>
                            ) : (
                              <Skeleton height="25px" width="50%"></Skeleton>
                            )}
                          </Col>
                          <Col md="auto" className=" my-auto small-svg">
                            <div className="d-flex align-items-center ">
                              <div className="text-center">
                                <div
                                  className="fs-075 small-svg white-space-nowrap cursor-pointer"
                                  onClick={handleScrollGotoScore}
                                >
                                  <span className="pe-1">
                                    <IconCup fillColor="#444" />
                                  </span>
                                  امتیاز
                                  <span className=" fs-normal ps-1">
                                    {!loadingImageSlider ? (
                                      amusementService.totalRank
                                    ) : (
                                      <Skeleton
                                        height="17px"
                                        width="15px"
                                      ></Skeleton>
                                    )}
                                  </span>{" "}
                                </div>
                              </div>

                              <div
                                className="text-center  ms-2 ps-2 cursor-pointer"
                                onClick={handleScrollGotoComment}
                              >
                                <div className="fs-075 small-svg white-space-nowrap ">
                                  <span className="pe-1">
                                    <IconClipBoard fillColor="#444" />
                                  </span>
                                  نظرات
                                  <span className=" fs-normal  ps-1">
                                    {!loadingImageSlider ? (
                                      amusementService?.amusementTestimonials
                                        ?.length
                                    ) : (
                                      <Skeleton
                                        height="17px"
                                        width="15px"
                                      ></Skeleton>
                                    )}
                                  </span>{" "}
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" className="border-top py-3">
                            {loadingImageSlider ? (
                              <Row className="mb-3 mt-2">
                                <Col md="3" xl="3" className="pe-0">
                                  <Skeleton
                                    height="40px"
                                    width="70%"
                                  ></Skeleton>
                                </Col>
                                <Col
                                  md="3"
                                  xl="3"
                                  className="text-center text-danger "
                                >
                                  <Skeleton
                                    height="40px"
                                    width="70%"
                                  ></Skeleton>
                                </Col>
                                <Col md="3" lg="2" xl="3" className="text-end ">
                                  <Skeleton
                                    height="40px"
                                    width="70%"
                                  ></Skeleton>
                                </Col>
                                <Col md="3" lg="4" xl="3">
                                  <Skeleton
                                    height="40px"
                                    width="100%"
                                  ></Skeleton>
                                </Col>
                                <Col xs="12" className="border-top mt-3"></Col>
                              </Row>
                            ) :
                              // amusementService.hasReserveDetail_V2 ? (
                              //   <>
                              <Row className="mb-3 mt-2">
                                <Col md="3" xl="3" className="pe-0">
                                  <>
                                    <div className="fs-07 text-black-06  pb-2">
                                      قیمت اولیه
                                      </div>
                                    <div>
                                      {!loadingImageSlider ? (
                                        <>
                                          <span className="text-decoration-line-throught-rotate border-black ">
                                            <SplitNumber
                                              number={
                                                amusementService.originalPrice
                                              }
                                            />
                                          </span>{" "}
                                            تومان
                                          </>
                                      ) : (
                                        <Skeleton
                                          height="17px"
                                          width="50%"
                                        ></Skeleton>
                                      )}
                                    </div>
                                  </>
                                </Col>
                                <Col
                                  md="3"
                                  xl="3"
                                  className="text-center text-danger px-0"
                                >
                                  <>
                                    <div className="text-center text-danger fs-07 pb-2">
                                      تخفیف ویژه
                                      </div>
                                    <div>
                                      {!loadingImageSlider ? (
                                        <>
                                          <span className=" small-svg">
                                            <span className="d-lg-none d-xl-inline-block pe-1">
                                              <IconGift fillColor="#f80248" />{" "}
                                            </span>
                                            <SplitNumber
                                              number={
                                                amusementService?.originalPrice -
                                                amusementService?.price
                                              }
                                            />{" "}
                                          </span>{" "}
                                            تومان
                                          </>
                                      ) : (
                                        <Skeleton
                                          height="17px"
                                          width="50%"
                                        ></Skeleton>
                                      )}
                                    </div>
                                  </>
                                </Col>
                                <Col
                                  md="3"
                                  lg="2"
                                  xl="3"
                                  className="text-end px-0"
                                >
                                  <div className="fs-07 text-black-06 pb-1">
                                    قیمت نهایی
                                    </div>
                                  <div>
                                    {!loadingImageSlider ? (
                                      <>
                                        <span className=" fw-bold fs-103">
                                          <SplitNumber
                                            number={amusementService.price}
                                          />
                                        </span>
                                          تومان
                                        </>
                                    ) : (
                                      <Skeleton
                                        height="17px"
                                        width="50%"
                                      ></Skeleton>
                                    )}
                                  </div>
                                </Col>
                                <Col
                                  md="3"
                                  lg="4"
                                  xl="3"
                                >
                                  {amusementService.hasReserveDetail_V2 ?
                                    <button
                                      className="btn btn-danger white-space-nowrap text-center fs-normal w-100 py-3"
                                      onClick={openModal}
                                    >
                                      افزودن به سبد خرید
                                    </button> :
                                    <OverlayTrigger
                                      placement="top"
                                      trigger="click"
                                      onEntered={() => {
                                        setTimeout(() => {
                                          setShowTooltip(false)
                                        }, 2000)
                                      }}
                                      show={showTooltip}
                                      overlay={
                                        <Tooltip id="tooltip-disabled">
                                          در حال حاضر این برنامه غیرفعال است.
                                        </Tooltip>
                                      }
                                    >
                                      <div
                                        onClick={() => {
                                          setShowTooltip(true)
                                        }}
                                      >
                                        <button disabled className="btn btn-outline-secondary w-100 white-space-nowrap text-center fs-normal w-100 py-3">
                                          افزودن به سبد خرید
                                        </button>
                                      </div>
                                    </OverlayTrigger>
                                  }
                                </Col>
                                <Col
                                  xs="12"
                                  className="border-top mt-3"
                                ></Col>
                              </Row>
                              /* </>
                            ) : (
                              <>
                                <Alert
                                  variant="danger"
                                  className="p-2 fs-085 mt-2 mb-3 d-inline-block"
                                >
                                  <IconErrorCircle fillColor="#58151c" /> تا
                                  اطلاع ثانوی این تفریح غیرفعال می باشد.
                                </Alert>
                              </>
                            )} */}

                            <Row>
                              <Col md className="pe-0 ps-2">
                                {amusementService.hasReserveDetail_V2 ? (
                                  <div className=" text-orange fs-08  user-version">
                                    <IconErrorCircle fillColor="#f76900db" />
                                    جهت مشاهده سانس و تاریخ، روی دکمه{" "}
                                    <span
                                      className="cursor-pointer px-1"
                                      onClick={openModal}
                                    >
                                      «افزودن به سبد خرید»
                                    </span>
                                    کلیک نمایید.
                                  </div>
                                ) : (
                                  " "
                                )}
                                <div className="fs-08 my-3 ">
                                  <IconErrorCircle fillColor="#444" />
                                  لطفا قبل از خرید این تفریح، نکات مهم و ضروری
                                  را مطالعه نمایید.
                                </div>
                                <div className="fs-08 small-svg text-success">
                                  <span className="me-1">
                                    <IconSecurity fillColor="#09a463" />
                                  </span>
                                  این سایت دارای{" "}
                                  <span className="fw-bold">مجوز رسمی</span> از
                                  سازمان میراث فرهنگی و گردشگری و وزارت صنعت و
                                  معدن می باشد.
                                </div>
                              </Col>
                              <Col xs="auto" className="text-end my-auto px-1">
                                <div className=" ">
                                  <a
                                    referrerPolicy="origin"
                                    target="_blank"
                                    href="https://trustseal.enamad.ir/?id=274889&amp;Code=A32132KLXam6f2jcPJyV"
                                  >
                                    <img
                                      alt="eNamad"
                                      referrerPolicy="origin"
                                      className="rounded-3 h-100 "
                                      src={enamadImage}
                                      style={{
                                        cursor: "pointer",
                                        width: "95px",
                                      }}
                                      id="A32132KLXam6f2jcPJyV"
                                    />
                                  </a>
                                </div>
                                {/* <img
                                  src={enamadImage}
                                  alt="map"
                                  style={{ width: "95px" }}
                                /> */}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Card.Body>
                    <Card.Footer className="border-top bg-light rounded-bottom-3">
                      {/**** آیکن های اعتمادسازی *********************************/}
                      <div className="d-flex justify-content-between small-svg py-1">
                        <div className="d-flex">
                          <div className="fw-bold fs-07">
                            <span className="me-1">
                              <IconCancelTicket fillColor="#09a463" />
                            </span>
                            امکان کنسلی
                          </div>
                          <div className="fs-07 ps-1 ps-lg-2">
                            به صورت آنلاین و تلفنی
                          </div>
                        </div>
                        <div className="d-flex">
                          <div className="fw-bold fs-07">
                            <span className="me-1">
                              <IconFast fillColor="#09a463" />
                            </span>
                            صدور آنی بلیط
                          </div>
                          <div className="fs-07 ps-1 ps-lg-2">
                            بدون نیاز به چاپ بلیط
                          </div>
                        </div>
                        <div className="d-flex">
                          <div className="fw-bold fs-07">
                            <span className="me-1">
                              <IconSecurity fillColor="#09a463" />
                            </span>
                            تضمین قیمت
                          </div>
                          <div className="fs-07 ps-1 ps-lg-2">
                            تفریحات با بیشترین تخفیف
                          </div>
                        </div>
                      </div>
                    </Card.Footer>
                  </Card>
                </Col>
              </Row>
              {/*********** باکس رزرو در حالت pre-render ****************************/}
              <Card className="rounded-3 shadow-sm border-0 bg-white prerender-version mt-3 ">
                <Card.Body>
                  {/* <ReserveBoxFoPreRender
                    reserveFormData={reserveDetail_V2}
                    serviceInfo={{
                      id: amusementService.id,
                      name: amusementService.name,
                      urlName: urlName,
                      imageUrl: amusementService.imageUrl,
                    }}
                    isInModal={false}
                  /> */}
                  {
                    <ReserveModal
                      reserveDetail_V2_Data={reserveDetail_V2}
                      show={showReserveModal}
                      onClose={closeModal}
                      serviceInfo={{
                        id: amusementService.id,
                        name: amusementService.name,
                        urlName: urlName,
                        imageUrl: amusementService.imageUrl,
                      }}
                      isModal={false}
                    />
                  }
                </Card.Body>
              </Card>

              {/****  نکات مهم و ضروری  ******************************/}
              <Card className="rounded-3 shadow-sm border-0 bg-white  mt-3">
                <Card.Body>
                  <div>
                    <span className="pe-2">
                      <IconBell fillColor="#000" />
                    </span>

                    <h2 className="d-inline-block fw-bold fs-102 pb-3">
                      نکات مهم و ضروری {amusementService.name}
                    </h2>
                  </div>
                  {loadingImageSlider ? (
                    <SkeletonTheme>
                      <Skeleton height="15px" count={5}></Skeleton>
                    </SkeletonTheme>
                  ) : (
                    <>
                      {!_.isEmpty(amusementService.suggestedPromoCode) ? (
                        <>
                          <div className="text-align-justify description-text d-flex align-items-center fw-bold">
                            <span> کد تخفیف خرید ارزان تر:</span>

                            <span className="text-danger mx-1">
                              {amusementService.suggestedPromoCode}
                            </span>
                            <Button
                              onClick={handleCopy}
                              variant="outline-secondary"
                              className="px-2 py-1 fs-07"
                            >
                              کپی
                            </Button>
                          </div>
                          <div className="text-align-justify description-text my-2 fw-bold">
                            (راهنما: تنها کافیست این کد تخفیف را در بخش سبد خرید
                            وارد نمایید.){" "}
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      <div
                        className="text-align-justify description-text"
                        dangerouslySetInnerHTML={{
                          __html: amusementService.alerts,
                        }}
                      />
                      {/* <div className="text-align-justify description-text">
                        <a
                          href="https://www.instagram.com/tafrihancom?igsh=MTJtcWt2Y2IwcWgwdg=="
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#e33642" }}
                        >
                          <IconInstagram />
                          <span className="mx-1">مشاهده اینستاگرام </span>
                        </a>
                      </div> */}
                    </>
                  )}
                </Card.Body>
              </Card>

              <Card className="rounded-3 shadow-sm border-0 bg-white  mt-3">
                <Card.Body>
                  <div>
                    <span className="pe-2">
                      <IconNote fillColor="#000" />
                    </span>
                    <h2 className="d-inline-block fw-bold fs-102 pb-3">
                      بررسی اجمالی {amusementService.name}
                    </h2>
                  </div>
                  {loadingImageSlider ? (
                    <SkeletonTheme>
                      <Skeleton height="15px" count={5}></Skeleton>
                    </SkeletonTheme>
                  ) : (
                    <>
                      <div
                        className="text-align-justify description-text"
                        dangerouslySetInnerHTML={{
                          __html: amusementService.description,
                        }}
                      />
                      <div className="text-align-justify description-text">
                        (<span className="fw-bold">توجه</span>: اطلاعات مندرج
                        شده در بخش بررسی اجمالی تفریح ممکن است بروز نباشد و یا
                        توسط مجموعه تفریحی تغییر کرده باشد و حتماً بخش نکات مهم
                        و ضروری در قسمت بالا هر تفریح را بررسی نمایید و در صورت
                        داشتن هر گونه سوال با پشتیبانی تفریحان تماس حاصل نمایید)
                      </div>
                    </>
                  )}
                </Card.Body>
              </Card>
              {showReserveModal && (
                <ReserveModal
                  reserveDetail_V2_Data={reserveDetail_V2}
                  show={showReserveModal}
                  onClose={closeModal}
                  serviceInfo={{
                    id: amusementService.id,
                    name: amusementService.name,
                    urlName: urlName,
                    imageUrl: amusementService.imageUrl,
                  }}
                  isModal={true}
                />
              )}
            </Container>
          </Container>

          <Container fluid className="" ref={ScrollGotoScore}>
            <Container className="px-0">
              <CommentScore amusementService={amusementService} />
              {/********** دسته بندی در حالت pre-render **********************/}
              <div className="scroll-container-box prerender-version">
                {amusementService?.cityAmusementGroups?.map((item) => (
                  <Link
                    to={`/c/${amusementService?.amusementServiceRegions[0].region
                      .englishName
                      }/${item.urlName?.split(" ").join("-")}`}
                    className="scroll-item"
                  >
                    {item.title} {amusementService?.amusementServiceRegions[0].region.name}
                  </Link>
                ))}
              </div>
              {/******** تفریحات مرتبط ***************************/}
              {amusementService?.relatedAmusementServices != null &&
                amusementService?.relatedAmusementServices.length > 0 && (
                  <Container className="px-0 pb-2 pt-5">
                    <h3 className=" fw-bold fs-102 "> تفریحات مرتبط </h3>
                    {loadingImageSlider ? (
                      <Swiper
                        className="amusement-swiper"
                        spaceBetween={10}
                        slidesPerView={"auto"}
                      >
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                      </Swiper>
                    ) : (
                      <Swiper
                        className="amusement-swiper"
                        spaceBetween={10}
                        slidesPerView={"auto"}
                      >
                        {amusementService?.relatedAmusementServices?.map(
                          (item) => (
                            <SwiperSlide key={item.id}>
                              <CardTile
                                itemImgSrc={
                                  process.env.REACT_APP_API_URL + item.imageUrl
                                }
                                amusementUrl={`/details/${item.urlName}`}
                                amusementName={item.name}
                                amusementPrice={item.price}
                                amusementFinalPrice={item.originalPrice}
                                handleClick={handleClick}
                              />
                            </SwiperSlide>
                          )
                        )}
                      </Swiper>
                    )}
                  </Container>
                )}
              {/************** نقشه ******************************************/}
              {amusementService.lat && amusementService.lon && (
                <Container className="px-0">
                  <Card
                    className="mt-3 rounded-3  shadow-sm bg-white text-dark "
                    style={{ lineHeight: "1.4rem" }}
                  >
                    <Card.Body className="">
                      <span className="pe-2">
                        <IconLocation1 fillColor="#000" />
                      </span>
                      <h3 className="d-inline-block  fw-bold fs-102 mb-4 ">
                        موقعیت {amusementService.name} روی نقشه
                      </h3>
                      <LocationMap
                        lat={amusementService.lat}
                        lng={amusementService.lon}
                        amusementName={amusementService.name}
                      />
                      {amusementService?.address && (
                        <div className="mt-3">
                          آدرس : {amusementService?.address}
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </Container>
              )}
              {/********  نظرات *********************************/}
              <section ref={ScrollGotoComment}>
                <CommentSlider amusementService={amusementService} />
              </section>
            </Container>
          </Container>
        </>
      )}
    </>
  );
}

export default IndexAmusementDetail;
